"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ContentBoxSeparator = (props) => {
    const TextTagName = props.as || 'div';
    return (react_1.default.createElement("div", { className: "relative my-2" },
        react_1.default.createElement("div", { className: "absolute inset-0 flex items-center" },
            react_1.default.createElement("div", { className: "w-full border-t border-misc-200" })),
        react_1.default.createElement("div", { className: "relative flex justify-center text-sm" },
            react_1.default.createElement(TextTagName, { className: "px-2 bg-white text-secondary-500" }, props.children))));
};
exports.default = ContentBoxSeparator;
//# sourceMappingURL=ContentBoxSeparator.js.map